import { ConnectedProps, connect } from "react-redux";
// import { IStoreState } from "../../reducers/types";
import { withRouter } from "react-router";
import { PackagesHotelsAvailability } from "./component";
import {
  fetchTravelWalletCreditHistory,
  fetchTravelWalletDetails,
} from "../travel-wallet/actions/actions";
import {
  fetchInitialPackagesAvailability,
  setPackageEntryPoint,
  stopFetchMorePackagesAvailability,
} from "./actions/actions";
import { IStoreState } from "../../reducers/types";
import {
  getPackageAvailabilitySearchDestinationLocationResult,
  getPackagesAvailabilityCallState,
  getPackagesAvailabilityDepartureDate,
  getPackagesAvailabilityReturnDate,
} from "./reducer";
import {
  getRewardsAccounts,
  getRewardsAccountWithLargestEarnForBanner,
} from "../rewards/reducer";

const mapStateToProps = (state: IStoreState) => ({
  packagesAvailabilityCallState: getPackagesAvailabilityCallState(state),
  largestValueAccount: getRewardsAccountWithLargestEarnForBanner(state),
  location: getPackageAvailabilitySearchDestinationLocationResult(state),
  fromDate: getPackagesAvailabilityDepartureDate(state),
  untilDate: getPackagesAvailabilityReturnDate(state),
  rewardsAccounts: getRewardsAccounts(state),
});

const mapDispatchToProps = {
  fetchTravelWalletDetails,
  fetchInitialPackagesAvailability,
  stopFetchMorePackagesAvailability,
  setPackageEntryPoint,
  fetchTravelWalletCreditHistory,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PackagesHotelsAvailabilityConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedPackagesHotelsAvailability = withRouter(
  connector(PackagesHotelsAvailability)
);
